<template>
  <v-container>
    <v-text-field
      prefix="Nombre:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.name"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.name == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <p class="text-h6">Variables tanque</p>
    <v-text-field
      prefix="Valor actual:"
      class="ml-3 mr-3"
      v-model.number="selectedItem.customized.value"
      single-line
      disabled
      type="number"
    />

    <v-text-field
      prefix="Valor máximo:"
      class="ml-3 mr-3"
      v-model.number="selectedItem.customized.maximum_value"
      single-line
      type="number"
      @click="updateEditing(true)"
      @keypress="isNumber($event)"
      :min="selectedItem.customized.value || 0"
    />

    <v-text-field
      prefix="Alarma:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_failure_alarm"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.variable_failure_alarm == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Motor:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_engine"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.variable_engine == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Volumen:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.volume_address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.volume_address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Temperatura:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.temp_address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.temp_address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Escritura Marcha:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.run_order_configuration?.customized.write_address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.run_order_configuration?.customized.write_address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Lectura Marcha:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.run_order_configuration?.customized.read_address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.run_order_configuration?.customized.read_address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Escritura Paro:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.stop_order_configuration?.customized.write_address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.stop_order_configuration?.customized.write_address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Lectura Paro:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.stop_order_configuration?.customized.read_address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.stop_order_configuration?.customized.read_address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Escritura Cont:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.continuous_order_configuration?.customized.write_address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.continuous_order_configuration?.customized.write_address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Lectura Cont:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.continuous_order_configuration?.customized.read_address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.continuous_order_configuration?.customized.read_address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Escritura Discont:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.discontinuous_order_configuration?.customized.write_address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.discontinuous_order_configuration?.customized.write_address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Lectura Discont:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.discontinuous_order_configuration?.customized.read_address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.discontinuous_order_configuration?.customized.read_address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Running time conf:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.running_time_configuration?.customized.address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.running_time_configuration?.customized.address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="Stopped time conf:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.stopped_time_configuration?.customized.address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.stopped_time_configuration?.customized.address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="variator speed:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variator_speed_configuration?.customized.address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.variator_speed_configuration?.customized.address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      prefix="volume calibration:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.volume_calibration_configuration?.customized.address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.volume_calibration_configuration?.customized.address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <!-- Bombas -->
    <p class="text-h6">Variables bomba</p>
    <v-checkbox
      class="mb-5"
      label="Bombas"
      v-model="selectedItem.customized.bomba"
      hide-details
    ></v-checkbox>

    <v-text-field
      v-if="selectedItem.customized.bomba"
      prefix="Motor bomba:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_continuous_running"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.variable_continuous_running == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      v-if="selectedItem.customized.bomba"
      prefix="Bomba alarma:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_bomb_failure_alarm"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.variable_bomb_failure_alarm == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <v-text-field
      v-if="selectedItem.customized.bomba"
      prefix="Orden marcha bomba:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_run_order"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.variable_run_order == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "KoioteTankCanvasQuesosProperties",

  computed: {
    ...mapState(["selectedItem"]),
  },

  methods: {
    ...mapActions(["updateEditing"]),

    isNumber($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        if (keyCode !== 46) {
          $event.preventDefault();
          return false;
        }
      }
    },
  },
};
</script>
